import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconUse", "isToolbarActive", "isTrellisTheme"];
import { TOOLBAR_DROPDOWN_ICON_BUTTON_WIDTH } from './constants';
import ToolbarIconButton from './ToolbarIconButton';
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarDropdownIconButton = props => {
  const {
      iconUse,
      isToolbarActive,
      isTrellisTheme
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(ToolbarIconButton, Object.assign({}, rest, {
    borderInlineEndWidth: "100",
    borderInlineStartWidth: "100",
    icon: DownCaratIcon,
    isToolbarActive: isToolbarActive,
    width: TOOLBAR_DROPDOWN_ICON_BUTTON_WIDTH,
    use: iconUse,
    variant: "dropdown",
    isTrellisTheme: isTrellisTheme
  }));
};
export const TrellisToolbarDropdownIconButton = ToolbarDropdownIconButton;
export default TrellisToolbarDropdownIconButton;